import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ROUTES } from 'core/const/routes';
import PageLayout from 'component/layouts/PageLayout';
import ApartmentFormFreeTexts from 'component/forms/apartment/ApartmentFormFreeTexts';
import { ICreateApartmentTunnel } from 'view/landlord/apartment/ApartmentCreateView';
import ProgressBar from 'component/atoms/ProgressBar';
import useWindowSize from 'core/hook/windowsize.hook';

const ApartmentFreeTextFormView: FC<ICreateApartmentTunnel> = ({ isTunnelView, progress = 10 }) => {
  const { t: r } = useTranslation('routes');
  const { isSmallerMd } = useWindowSize();

  return (
    <PageLayout
      showPageTitle={false}
      pageTitle={r(ROUTES.landlordRoutes.apartment.mainInformation.title)}
      showBackButton={isSmallerMd && !isTunnelView}
      hideMenu={isTunnelView}
    >
      {isTunnelView && <ProgressBar progress={progress} />}
      <ApartmentFormFreeTexts isTunnelView={isTunnelView} />
    </PageLayout>
  );
};

export default ApartmentFreeTextFormView;
